import React, { Component } from 'react';
import { CircularProgress } from '@material-ui/core';
import CustomerTabs from '../../components/Tabs/CustomerTabs';
import withUser from '../../components/HOC/HOCwithUser.jsx';
import HOCLoader from '../../components/HOC/HOCLoader.jsx';
import { ROLE_CUSTOMER, ROLE_PROVIDER } from '../../utils/config/constants';
import ProviderTabs from '../../components/Tabs/ProviderTabs';
const sendProps = props => {
    const { classes, ...rest } = props;
    return rest;
};
export class MainProfile extends Component {
    renderImage = () => {
        if (this.props.userData.image) {
            <img
                src={this.props.userData.image.medium}
                className="profile-pic"
                width="200px"
                height="200px"
            />;
        } else {
            <CircularProgress />;
        }
    };
    render() {
        const { userData } = this.props;
        return (
            <HOCLoader loading={this.props.isLoading}>
                <div>
                    {userData && (
                        <div>
                            {this.props.userData.role == ROLE_CUSTOMER && (
                                <CustomerTabs {...sendProps(this.props)} />
                            )}
                            {this.props.userData.role == ROLE_PROVIDER && (
                                <ProviderTabs {...sendProps(this.props)} />
                            )}
                        </div>
                    )}
                </div>
            </HOCLoader>
        );
    }
}

export default withUser(MainProfile);



// WEBPACK FOOTER //
// ./src/views/User/MainProfile.jsx